import ChartsWithValidation from '../Components/ChartsWithValidation';
const Dashboard = () => {
    return <ChartsWithValidation />;
};
export default Dashboard;
